export class OcorrenciaHistorico {
  id: number;
  idOcorrencia: number;
  idFuncionario: number;
  funcionario: string;
  texto: string;
  data: Date;
  ocultar: boolean;
  usuarios: number[];
}
